<template>
  <body class="datepicker_mobile_full">
    <div id="page">
      <header class="header menu_fixed">
        <div id="preloader"><div data-loader="circle-side"></div></div>
        <!-- /Page Preload -->
        <div id="logo">
          <a href="/">
            <!-- <img
              src="../../public/frontend/img/logo.svg"
              width="150"
              height="36"
              alt=""
              class="logo_normal"
            />
            <img
              src="../../public/frontend/img/logo_sticky.svg"
              width="150"
              height="36"
              alt=""
              class="logo_sticky"
            /> -->
            <h1 style="color: #f54149" class="logo_normal">Peekzy</h1>
            <h1 style="color: #f54149" class="logo_sticky">Peekzy</h1>
          </a>
        </div>

        <ul v-if="!loggedIn" class="mr-auto" id="top_menu">
          <!-- <MenuLink path="/signin" text="Signin" class="login"></MenuLink> -->
          <li>
            <router-link to="/signin" id="sign-in" class="" title="Sign In"
              >Sign In</router-link>
          </li>
        </ul>
        <ul v-else class="mr-auto" id="top_menu">
          <li><router-link to="/my-account">My Account</router-link></li>
          <li>
            <a href="#" @click.prevent="logout()">Logout</a>
          </li>
          <li>
            <!-- <Translator /> -->
          </li>
        </ul>

        <!-- /top_menu -->
        <a href="#menu" class="btn_mobile">
          <div class="hamburger hamburger--spin" id="hamburger">
            <div class="hamburger-box">
              <div class="hamburger-inner"></div>
            </div>
          </div>
        </a>
        <!--Frontnav /-->
        <app-nav :loggedIn="loggedIn"></app-nav>
      </header>
      <!-- /header -->

      <main>
        <slot></slot>
      </main>
      <!-- /main -->

      <footer>
        <div class="container margin_60_35">
          <div class="row">
            <div class="col-lg-5 col-md-12 p-r-5">
              <p>
                <!--img
                  src="../../public/frontend/img/logo.svg"
                  width="150"
                  height="36"
                  alt=""
                /-->
                Travel friend
              </p>
              <p>
                Mea nibh meis philosophia eu. Duis legimus efficiantur ea sea.
                Id placerat tacimates definitionem sea, prima quidam vim no. Duo
                nobis persecuti cu. Nihil facilisi indoctum an vix, ut delectus
                expetendis vis.
              </p>
              <div class="follow_us">
                <ul>
                  <li>Follow us</li>
                  <li>
                    <a href="#0"><i class="ti-facebook"></i></a>
                  </li>
                  <li>
                    <a href="#0"><i class="ti-twitter-alt"></i></a>
                  </li>
                  <li>
                    <a href="#0"><i class="ti-google"></i></a>
                  </li>
                  <li>
                    <a href="#0"><i class="ti-pinterest"></i></a>
                  </li>
                  <li>
                    <a href="#0"><i class="ti-instagram"></i></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 ml-lg-auto">
              <h5>Useful links</h5>

              <ul class="links">
                <li><router-link to="/about">About11</router-link></li>
                <li v-if="!loggedIn">
                <router-link to="/signup">Tourist Registration</router-link>
                </li>
                <li v-if="!loggedIn">
                  <span
                    ><router-link to="/merchant-signup">Merchant Registrationsdsd</router-link></span
                  >
                </li>
                <li v-else><a href="#" @click.prevent="logout()">Logout</a></li>
                <li><a href="/posts">News &amp; Events</a></li>
                <li><a href="/contact">Contacts</a></li>
              </ul>
            </div>
            <div class="col-lg-3 col-md-6">
              <h5>Contact with Us</h5>
              <ul class="contacts">
                <li>
                  <a href="tel://61280932400"
                    ><i class="ti-mobile"></i> 08108765848</a
                  >
                </li>
                <li>
                  <a href="mailto:info@Panagea.com"
                    ><i class="ti-email"></i> info@travelfriend.com</a
                  >
                </li>
              </ul>
              <div id="newsletter">
                <h6>Newsletter</h6>
                <div id="message-newsletter"></div>
                <form
                  method="post"
                  action="assets/newsletter.php"
                  name="newsletter_form"
                  id="newsletter_form"
                >
                  <div class="form-group">
                    <input
                      type="email"
                      name="email_newsletter"
                      id="email_newsletter"
                      class="form-control"
                      placeholder="Your email"
                    />
                    <input
                      type="submit"
                      value="Submit"
                      id="submit-newsletter"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!--/row-->
          <hr />
          <div class="row">
            <div class="col-lg-6">
              <ul id="footer-selector">
                <li>
                  <div class="styled-select" id="lang-selector">
                    <select>
                      <option value="English" selected>English</option>
                      <option value="French">French</option>
                      <option value="Spanish">Spanish</option>
                      <option value="Russian">Russian</option>
                    </select>
                  </div>
                </li>
                <li>
                  <div class="styled-select" id="currency-selector">
                    <select>
                      <option value="US Dollars" selected>US Dollars</option>
                      <option value="Euro">Euro</option>
                    </select>
                  </div>
                </li>
                <li>
                  <!-- <img src="../../public/frontend/img/cards_all.svg" alt="" /> -->
                </li>
              </ul>
            </div>
            <div class="col-lg-6">
              <ul id="additional_links">
                <li><a href="#0">Terms and conditions</a></li>
                <li><a href="#0">Privacy</a></li>
                <li><span>© 2019 Travel Friend</span></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <!--/footer-->
    </div>
    <!-- page -->

    <a id="toTop" @click.self="this.$scrollToTop"></a>
    <!-- Back to top button -->
  </body>
</template>
<script>
//import Frontnav from "./Frontnav.vue";
import Nav from "../cmps/Nav";
//import { Translator } from "vue-google-translate";
export default {
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },

  name: "Frontendlayout",
  computed: {
    loggedIn() {
      return this.$store.getters.loginState;
    },
  },
  components: {
    // Frontnav,
    appNav: Nav,
    //Translator,
  },
};
</script>
<style>
body {
  top: 0 !important;
}
/* get rids of the banner at the bottom of the web page */
.skiptranslate {
  display: none !important;
}
.main-menu > ul > li span > a {
  color: #f54149 !important;
}
header.sticky .main-menu > ul > li span > a,
.sticky ul#top_menu li a.login:before {
  color: #444 !important;
}
ul#top_menu li a {
  position: relative;
  top: 15px;
  color: #f54149;
  font-weight: 600;
}
ul#top_menu li a:hover {
  color: #f54149;
}
ul#top_menu {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
